import actions from './actions';

const {
  MAIL_READ_BEGIN,
  MAIL_READ_SUCCESS,
  MAIL_READ_ERR,

  MAIL_ADD_BEGIN,
  MAIL_ADD_SUCCESS,
  MAIL_ADD_ERR,

  GET_MAIL_READ_BEGIN,
  GET_MAIL_READ_SUCCESS,
  GET_MAIL_READ_ERR,

  GET_LEAVES_READ_BEGIN,
  GET_LEAVES_READ_SUCCESS,
  GET_LEAVES_READ_ERR,

  LEAVEUPDATE_UPDATE_BEGIN,
  LEAVEUPDATE_UPDATE_SUCCESS,
  LEAVEUPDATE_UPDATE_ERR,


  GET_LEAVESREQUEST_READ_BEGIN,
  GET_LEAVESREQUEST_READ_SUCCESS,
  GET_LEAVESREQUEST_READ_ERR,


  GET_LEAVESDATA_READ_BEGIN,
  GET_LEAVESDATA_READ_SUCCESS,
  GET_LEAVESDATA_READ_ERR,

} = actions;

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const addinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const mailInitialState = {
  data: null,
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};
const updateinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};


const GETLEAVESDATAReducer = (state = mailInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_LEAVESDATA_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case GET_LEAVESDATA_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case GET_LEAVESDATA_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};


const MAILReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case MAIL_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case MAIL_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case MAIL_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const GETMAILReducer = (state = mailInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_MAIL_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case GET_MAIL_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case GET_MAIL_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const MAILAddReducer = (state = addinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case MAIL_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case MAIL_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case MAIL_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const GETLEAVESReducer = (state = mailInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_LEAVES_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case GET_LEAVES_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case GET_LEAVES_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};


const GETLEAVESREQUESTReducer = (state = mailInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_LEAVESREQUEST_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case GET_LEAVESREQUEST_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case GET_LEAVESREQUEST_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};


const LEAVEUPDATEUpdateReducer = (state = updateinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LEAVEUPDATE_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case LEAVEUPDATE_UPDATE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case LEAVEUPDATE_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { MAILAddReducer, GETLEAVESDATAReducer, MAILReducer, GETMAILReducer, GETLEAVESReducer, GETLEAVESREQUESTReducer, LEAVEUPDATEUpdateReducer, };
